import React, {Component} from 'react';
import PropTypes from 'prop-types';


import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { Box, Button, DialogActions, DialogTitle } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet'
import L, { LatLngBoundsExpression, LatLngExpression } from 'leaflet';
import 'leaflet/dist/leaflet.css';
import ClosableBar from '../dialogs/ClosableBar';


const s:any = {
  dialogcontent: {
    backgroundColor: 'white',
    width:'100%',
  },
  root: {
    flex: '1 1 auto',
    background: 'background.paper',
  },
};

class MapPreview extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any = {zoom:13};
  constructor(props:any) {
    super(props);
    this.state = {
      loading: false,
      open: false,
    };
  }

  render() {
    const {open,position:pos,zoom,info,onClose} = this.props;
    const title = 'Location Preview';
    // const dialogClasses = {
    //   paper: classes.dialogcontent
    // }
    //const position = [51.505, -0.09]; //point
    const center:LatLngExpression = [8.00946644, -1.2221927];
    const position:LatLngExpression = (pos[0]===undefined || pos[1]===undefined)?center:pos;
    const bounds:LatLngBoundsExpression = [[4.71046214438, -3.24437008301],[11.0983409693, 1.0601216976]];
    //console.log('MapPreview:',open,position,zoom,info);
    return (
      <Dialog open={open} sx={{...s.dialog}} slotProps={{paper:{sx:s.dialogcontent}}} onClose={onClose} draggable={true}>
        <DialogTitle sx={{...s.titlebar}}><ClosableBar onClose={onClose}>{title}</ClosableBar></DialogTitle>
        <DialogContent sx={{...s.dialogcontent}}>
          <Box sx={{...s.root}}>
            <MapContainer center={position} zoom={zoom} scrollWheelZoom={false} style={{height:600,width:'100%'}}>
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution="&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
                bounds={bounds}
              />
              <Marker position={position}>
                <Popup>{info}</Popup>
              </Marker>
            </MapContainer>  
          </Box>
        </DialogContent>
        {/* <DialogActions>
          <Button variant="contained" color="secondary" onClick={onClose}><CloseIcon/>Close </Button>
        </DialogActions> */}
      </Dialog>
    );
  }
}

MapPreview.defaultProps = {
  position: [20,10],
  zoom: 13,
  // open: false,
  info: 'Current Location',
};

MapPreview.propTypes = {
  open: PropTypes.bool,
  position: PropTypes.array.isRequired,
  zoom: PropTypes.number,
  info: PropTypes.string,
  onClose: PropTypes.func
};

export default MapPreview;
